import { Component, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    templateUrl: './success-message.component.html',
    styleUrls: ['./success-message.component.scss'],
    standalone: false
})
export class SuccessMessageComponent {
  constructor(private matSnackBarRef: MatSnackBarRef<SuccessMessageComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public message: string) {
  }

  dismiss() {
    this.matSnackBarRef.dismiss();
  }
}
